import { MapPin } from 'lucide-react';
import { cx, FOCUS } from './ui';

export const GRID = 'grid grid-cols-2 gap-x-4 gap-y-6 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-6';

export function PhotoCard({ photo, onClick, title, subtitle, badge, index, footer }) {
  return (
    <div className="group min-w-0">
      <button type="button" onClick={onClick} className={cx('block w-full rounded-xl text-left', FOCUS)}>
        <div className="relative aspect-[4/5] overflow-hidden rounded-xl border border-umber/15 bg-umber/[0.06]">
          <img
            src={photo.thumb_url || photo.url}
            alt=""
            loading="lazy"
            className="h-full w-full object-cover transition duration-300 group-hover:scale-[1.025]"
          />
          <div className="pointer-events-none absolute inset-0 rounded-xl transition group-hover:bg-ink/[0.06]" />
          {index !== undefined && (
            <span className="absolute left-2 top-2 rounded-md bg-ink/75 px-1.5 py-0.5 font-mono text-[10px] tabular-nums text-parchment">
              {String(index).padStart(3, '0')}
            </span>
          )}
          {photo.gps && (
            <span className="absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded-full bg-vellum/90 text-ink" title="Con GPS">
              <MapPin className="h-3 w-3" strokeWidth={2} />
            </span>
          )}
          {badge && <span className="absolute bottom-2 left-2 rounded-full bg-vellum">{badge}</span>}
        </div>
        <p className="mt-2.5 truncate text-[13px] font-medium text-ink">{title}</p>
        {subtitle && <p className="mt-0.5 truncate font-mono text-[10.5px] uppercase tracking-[0.08em] text-umber/50">{subtitle}</p>}
      </button>
      {footer}
    </div>
  );
}

export function PhotoGridSkeleton({ count = 12 }) {
  return (
    <div className={GRID}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i}>
          <div className="aspect-[4/5] animate-pulse rounded-xl bg-umber/[0.07]" />
          <div className="mt-2.5 h-3 w-3/4 animate-pulse rounded bg-umber/[0.07]" />
          <div className="mt-1.5 h-2.5 w-1/2 animate-pulse rounded bg-umber/[0.05]" />
        </div>
      ))}
    </div>
  );
}
